// extracted by mini-css-extract-plugin
export default {"checkbox":"de4Npi","checked":"vYzOUT","disabled":"PaIfeJ","focus":"TxMWDn"};